var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.122 16.017c-.611-1.225-2.7-1.993-5.591-3.056-.55-.201-.897-.284-1.052-.732a1.426 1.426 0 01.13-1.324c1.145-1.238 1.708-3.093 1.708-5.488C14.317 2.25 12.15.833 10 .833S5.683 2.25 5.683 5.417c0 2.395.563 4.25 1.709 5.488a1.426 1.426 0 01.129 1.324c-.155.448-.5.531-1.052.732-2.89 1.063-4.98 1.833-5.592 3.056A8.808 8.808 0 000 19.583.417.417 0 00.417 20h19.166a.417.417 0 00.417-.417 8.808 8.808 0 00-.877-3.566z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.50764b5c.svg";
export { ForwardRef as ReactComponent };